import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizenVerifyPhoneNumber} from './citizen-verify-phone-number.model';
import * as CitizenVerifyPhoneNumberActions from './citizen-verify-phone-number.actions';

export const citizenVerifyPhoneNumbersFeatureKey = 'citizenVerifyPhoneNumbers';

export interface State extends EntityState<CitizenVerifyPhoneNumber> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizenVerifyPhoneNumber> = createEntityAdapter<CitizenVerifyPhoneNumber>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizenVerifyPhoneNumberActions.addCitizenVerifyPhoneNumber,
    (state, action) => adapter.addOne(action.citizenVerifyPhoneNumber, state)
  ),
  on(CitizenVerifyPhoneNumberActions.upsertCitizenVerifyPhoneNumber,
    (state, action) => adapter.upsertOne(action.citizenVerifyPhoneNumber, state)
  ),
  on(CitizenVerifyPhoneNumberActions.addCitizenVerifyPhoneNumbers,
    (state, action) => adapter.addMany(action.citizenVerifyPhoneNumbers, state)
  ),
  on(CitizenVerifyPhoneNumberActions.upsertCitizenVerifyPhoneNumbers,
    (state, action) => adapter.upsertMany(action.citizenVerifyPhoneNumbers, state)
  ),
  on(CitizenVerifyPhoneNumberActions.updateCitizenVerifyPhoneNumber,
    (state, action) => adapter.updateOne(action.citizenVerifyPhoneNumber, state)
  ),
  on(CitizenVerifyPhoneNumberActions.updateCitizenVerifyPhoneNumbers,
    (state, action) => adapter.updateMany(action.citizenVerifyPhoneNumbers, state)
  ),
  on(CitizenVerifyPhoneNumberActions.deleteCitizenVerifyPhoneNumber,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizenVerifyPhoneNumberActions.deleteCitizenVerifyPhoneNumbers,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizenVerifyPhoneNumberActions.loadCitizenVerifyPhoneNumbers,
    (state, action) => adapter.setAll(action.citizenVerifyPhoneNumbers, state)
  ),
  on(CitizenVerifyPhoneNumberActions.clearCitizenVerifyPhoneNumbers,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
